import loadable from "@loadable/component"
import { Navigate, RouteObject } from "react-router-dom"
import { APP_ROUTES } from "~/shared/constants/routes"
import { useUserInfo } from "~/store/user/userSlice"

// Keep the feature implementation available while it is disabled in production UI.
export const DISTRIBUTION_RULES_UI_ENABLED = false

const DistributionRulesPage = loadable(
  async () => import("./pages/DistributionRulesPage"),
  { fallback: <div>Loading...</div> },
)

export const distributionRulesRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.distributionRules,
    element: <SuperAdminDistributionRulesRoute />,
  },
]

function SuperAdminDistributionRulesRoute() {
  const { user } = useUserInfo()
  const isSuperAdmin = user?.user?.roles?.some(
    (role) => String(role) === "SuperAdmin",
  )

  return DISTRIBUTION_RULES_UI_ENABLED && isSuperAdmin ? (
    <DistributionRulesPage />
  ) : (
    <Navigate replace to={APP_ROUTES.home} />
  )
}
